import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Slide from 'react-reveal/Slide';
import './styles/contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        subject: '',
        message: '',
        inquiryType: 'general'
    });
    const [showAlert, setShowAlert] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Here you would typically send the form data to your backend
        console.log('Form submitted:', formData);
        setShowAlert(true);
        // Reset form
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            company: '',
            subject: '',
            message: '',
            inquiryType: 'general'
        });
        // Hide alert after 5 seconds
        setTimeout(() => setShowAlert(false), 5000);
    };

    const contactInfo = [
        {
            icon: "📧",
            title: "Email Us",
            details: "fastrac.pasada@tip.edu.ph",
            description: "Send us an email anytime"
        },
        {
            icon: "📞",
            title: "Call Us",
            details: "(+632) 8911-0964 ext. 312",
            description: "Mon-Fri 8:00 AM - 5:00 PM"
        },
        {
            icon: "📍",
            title: "Visit Us",
            details: "938 Aurora Blvd., Cubao, Quezon City, Philippines",
            description: "Our main office location"
        },
        {
            icon: "💬",
            title: "Live Chat",
            details: "Available 8:00 AM - 5:00 PM",
            description: "Get instant support online"
        }
    ];

    const offices = [
        {
            city: "Quezon City",
            address: "938 Aurora Blvd., Cubao, Quezon City",
            phone: "(+632) 8911-0964 ext. 312",
            email: "fastrac.pasada@tip.edu.ph",
            image: "https://via.placeholder.com/400x200/667eea/ffffff?text=Manila+Office"
        },
        // {
        //     city: "Cebu",
        //     address: "456 Technology Park, Lahug, Cebu City",
        //     phone: "+63 32 123 4567",
        //     email: "cebu@pasadaph.com",
        //     image: "https://via.placeholder.com/400x200/4facfe/ffffff?text=Cebu+Office"
        // },
        // {
        //     city: "Davao",
        //     address: "789 Business Center, Davao City",
        //     phone: "+63 82 123 4567",
        //     email: "davao@pasadaph.com",
        //     image: "https://via.placeholder.com/400x200/38ef7d/ffffff?text=Davao+Office"
        // }
    ];

    const teamMembers = [
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    },
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    },
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    },
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    },
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    },
    {
        name: "",
        position: "",
        department: "",
        expertise: "",
        experience: "",
        education: "",
        image: "",
        bio: ""
    }
];


    const faqs = [
        {
            question: "How do I get started with PASADA?",
            answer: "Getting started is easy! Contact our sales team and we'll guide you through the onboarding process for your specific needs."
        },
        {
            question: "What support do you provide?",
            answer: "We offer 24/7 technical support, training programs, and dedicated account management for all our clients."
        },
        {
            question: "Can PASADA integrate with existing systems?",
            answer: "Yes, PASADA is designed to integrate seamlessly with most existing transportation and payment systems."
        },
        {
            question: "Do you offer custom solutions?",
            answer: "Absolutely! We work closely with clients to develop tailored solutions that meet their specific transportation needs."
        }
    ];

    return (
        <div className="contact-page">
            <Helmet>
                <title>Contact Us - PASADA</title>
                <meta name="description" content="Get in touch with PASADA for transportation technology solutions. Contact our team for support, partnerships, or inquiries." />
                <link rel="canonical" href="/contact" />
            </Helmet>

            {/* Hero Section */}
            <section className="contact-hero">
                <Container>
                    <Row className="align-items-center min-vh-60">
                        <Col lg={8} md={10} className="mx-auto text-center">
                            <Slide bottom>
                                <h1 className="hero-title">Get In Touch</h1>
                                <p className="hero-subtitle">
                                    Ready to transform your transportation experience? We'd love to hear from you.
                                </p>
                            </Slide>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Info Cards */}
            <section className="contact-info py-5 bg-light">
                <Container>
                    <Row>
                        {contactInfo.map((info, index) => (
                            <Col lg={3} md={6} className="mb-4" key={index}>
                                <Slide bottom delay={index * 100}>
                                    <Card className="contact-card h-100 text-center shadow-sm">
                                        <Card.Body>
                                            <div className="contact-icon mb-3">{info.icon}</div>
                                            <h5 className="contact-title">{info.title}</h5>
                                            <p className="contact-details">{info.details}</p>
                                            <small className="contact-description">{info.description}</small>
                                        </Card.Body>
                                    </Card>
                                </Slide>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Contact Form and Map */}
            <section className="contact-form-section py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Slide bottom>
                                <div className="text-center mb-5">
                                    <h2>Send Us a Message</h2>
                                    <p className="lead">Fill out the form below and we'll get back to you within 24 hours.</p>
                                </div>
                            </Slide>
                        </Col>
                    </Row>
                    
                    {showAlert && (
                        <Row>
                            <Col lg={8} className="mx-auto">
                                <Alert variant="success" className="text-center">
                                    <strong>Thank you!</strong> Your message has been sent successfully. We'll get back to you soon.
                                </Alert>
                            </Col>
                        </Row>
                    )}

                    <Row>
                        <Col lg={8} className="mx-auto">
                            <Slide bottom delay={200}>
                                <Card className="contact-form-card shadow-lg">
                                    <Card.Body className="p-5">
                                        <Form onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>First Name *</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="firstName"
                                                            value={formData.firstName}
                                                            onChange={handleInputChange}
                                                            required
                                                            className="custom-input"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Last Name *</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="lastName"
                                                            value={formData.lastName}
                                                            onChange={handleInputChange}
                                                            required
                                                            className="custom-input"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Email Address *</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleInputChange}
                                                            required
                                                            className="custom-input"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <Form.Control
                                                            type="tel"
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleInputChange}
                                                            className="custom-input"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Company/Organization</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="company"
                                                            value={formData.company}
                                                            onChange={handleInputChange}
                                                            className="custom-input"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Inquiry Type</Form.Label>
                                                        <Form.Select
                                                            name="inquiryType"
                                                            value={formData.inquiryType}
                                                            onChange={handleInputChange}
                                                            className="custom-input"
                                                        >
                                                            <option value="general">General Inquiry</option>
                                                            <option value="sales">Sales & Partnerships</option>
                                                            <option value="support">Technical Support</option>
                                                            <option value="media">Media & Press</option>
                                                            <option value="careers">Careers</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Subject *</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="subject"
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    required
                                                    className="custom-input"
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-4">
                                                <Form.Label>Message *</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleInputChange}
                                                    required
                                                    className="custom-input"
                                                    placeholder="Tell us about your project or how we can help you..."
                                                />
                                            </Form.Group>

                                            <div className="text-center">
                                                <Button type="submit" size="lg" className="contact-submit-btn">
                                                    Send Message
                                                </Button>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Slide>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Office Locations */}
            <section className="office-locations py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center mb-5">
                            <h2>Our Offices</h2>
                            <p className="lead">Visit us at any of our locations across the Philippines</p>
                        </Col>
                    </Row>
                    <Row>
                        {offices.map((office, index) => (
                            <Col lg={4} md={6} className="mb-4" key={index}>
                                <Slide bottom delay={index * 100}>
                                    <Card className="office-card shadow-sm">
                                        <div className="office-image-wrapper">
                                            <img 
                                                src={office.image} 
                                                className="office-image"
                                                alt={`${office.city} Office`}
                                                onError={(e) => {
                                                    e.target.src = "https://via.placeholder.com/400x200/cccccc/ffffff?text=Office+Image";
                                                }}
                                            />
                                        </div>
                                        <Card.Body>
                                            <h5 className="office-city">{office.city}</h5>
                                            <div className="office-details">
                                                <p><strong>📍</strong> {office.address}</p>
                                                <p><strong>📞</strong> {office.phone}</p>
                                                <p><strong>📧</strong> {office.email}</p>
                                            </div>
                                            <Button variant="outline-primary" className="office-btn">
                                                Get Directions
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Slide>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* Our Teams Section */}
            <section className="our-teams py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center mb-5">
                            <h2>Meet Our Team</h2>
                            <p className="lead">The brilliant minds behind PASADA's innovative transportation solutions</p>
                        </Col>
                    </Row>
                    <Row>
                        {teamMembers.map((member, index) => (
                            <Col lg={4} md={6} className="mb-4" key={index}>
                                <Slide bottom delay={index * 100}>
                                    <Card className="team-card h-100 shadow-sm">
                                        <div className="team-image-wrapper">
                                            <img 
                                                src={member.image} 
                                                className="team-image"
                                                alt={member.name}
                                                onError={(e) => {
                                                    e.target.src = "https://via.placeholder.com/200x200/cccccc/ffffff?text=Team+Member";
                                                }}
                                            />
                                        </div>
                                        <Card.Body className="text-center">
                                            <h5 className="team-name">{member.name}</h5>
                                            <h6 className="team-position">{member.position}</h6>
                                            <p className="team-department">{member.department}</p>
                                            
                                            <div className="team-details mb-3">
                                                <div className="detail-item">
                                                    <strong>Expertise:</strong> {member.expertise}
                                                </div>
                                                <div className="detail-item">
                                                    <strong>Experience:</strong> {member.experience}
                                                </div>
                                                <div className="detail-item">
                                                    <strong>Education:</strong> {member.education}
                                                </div>
                                            </div>
                                            
                                            <p className="team-bio">{member.bio}</p>
                                            
                                            <div className="team-social">
                                                <Button variant="outline-primary" size="sm" className="me-2">
                                                    LinkedIn
                                                </Button>
                                                <Button variant="outline-secondary" size="sm">
                                                    Email
                                                </Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Slide>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* FAQ Section */}
            <section className="faq-section py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <div className="text-center mb-5">
                                <h2>Frequently Asked Questions</h2>
                                <p className="lead">Quick answers to common questions</p>
                            </div>
                            
                            {faqs.map((faq, index) => (
                                <Slide bottom delay={index * 100} key={index}>
                                    <Card className="faq-card mb-3 shadow-sm">
                                        <Card.Body>
                                            <h6 className="faq-question">{faq.question}</h6>
                                            <p className="faq-answer">{faq.answer}</p>
                                        </Card.Body>
                                    </Card>
                                </Slide>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="contact-cta py-5 bg-primary text-white">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center">
                            <Slide bottom>
                                <h2>Ready to Get Started?</h2>
                                <p className="lead mb-4">
                                    Join thousands who are already transforming transportation with PASADA.
                                </p>
                                <Button variant="light" size="lg" className="me-3 mb-2">
                                    Schedule a Demo
                                </Button>
                                <Button variant="outline-light" size="lg">
                                    Download Brochure
                                </Button>
                            </Slide>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Contact;